// 搜尋繁簡互通：比對前兩邊都轉成簡體並小寫，同一個字不論輸入繁體或簡體都搜得到
import { TRADITIONAL_SIMPLIFIED_PAIRS } from './hanSearchMap';

let simplifiedOf = null;

function table() {
  if (!simplifiedOf) {
    simplifiedOf = new Map();
    for (let i = 0; i < TRADITIONAL_SIMPLIFIED_PAIRS.length; i += 2) {
      simplifiedOf.set(TRADITIONAL_SIMPLIFIED_PAIRS[i], TRADITIONAL_SIMPLIFIED_PAIRS[i + 1]);
    }
  }
  return simplifiedOf;
}

// 字串長度不變（字表只收一對一的字），可直接用於標亮位置
export function normalizeHan(value) {
  if (value == null) return '';
  const map = table();
  let result = '';
  for (const char of String(value).toLocaleLowerCase()) result += map.get(char) || char;
  return result;
}

export function hanIncludes(haystack, needle) {
  return normalizeHan(haystack).includes(normalizeHan(needle));
}

// Vuetify customFilter：與內建過濾相同的回傳格式（所有相符區段），只是先做繁簡正規化
export function hanFilter(value, query) {
  if (value == null || query == null) return -1;
  if (!String(query).length) return 0;
  const text = normalizeHan(value);
  const target = normalizeHan(query);
  const result = [];
  let index = text.indexOf(target);
  while (index !== -1) {
    result.push([index, index + target.length]);
    index = text.indexOf(target, index + target.length);
  }
  return result.length ? result : -1;
}
